import { Alert, Box, Chip, Stack } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import { CloudUpload, Download } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab"
import { txt } from "../../services/translation"

export default function Drop({id, label, value, onChange, maxSize, loading, error, accept}){

    const [err, setErr] = useState(false)

    const [max] = useState(maxSize || 1000000)

    useEffect(() => {

        setErr(error)

    }, [error])


    const handleFile = file => {
        
        if (Array.isArray(accept) && !accept.includes(file.type)) {

            return setErr(txt('errorFileTypeNotAccepted'));

        } else if (file.size > max) {

            return setErr(txt('errorFileTooLarge'));
        }
        

        setErr(false);

        file.url = URL.createObjectURL(file);

        return onChange(file);
    }

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = value?.url;
        link.setAttribute('download', id);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
        document.body.appendChild(link);
        link.click();
    }

    const handleChange = e => {
        let files = e.target.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrop = e => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrag = e => {
        e.preventDefault();
    }

    const handleDelete = () => {
        document.getElementById(id).value = '';
        return onChange(null);
    }

    return <Stack spacing={1}>

        <LoadingButton 
            startIcon={<CloudUpload />} 
            variant='outlined'
            onClick={() => document.getElementById(id).click()}
            loading={loading}
            sx={{flex: 1, borderStyle: 'dashed', minHeight: 80}}
            onDrop={handleDrop}
            onDragOver={handleDrag}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            size='large'
        >
            {label || txt('dropFile')}
        </LoadingButton>


        {err && 
            <Alert severity='error'>{err}</Alert>
        }

        <input
            id={id} 
            type="file" 
            style={{display: 'none'}}
            onChange={handleChange}
            accept={Array.isArray(accept) ? accept.join(',') : ''}
        />

        {value?.url && 
            <Box>
                <Chip
                    label={value.name || txt('fileToUpload')}
                    icon={<Download />}
                    onClick={handleDownload}
                    onDelete={handleDelete}
                />
            </Box>
        }

    </Stack>
}